import { Divider as MuiDivider } from '@mui/material';
import type { DividerProps as MuiDividerProps } from '@mui/material';

export const Divider = MuiDivider;
export type DividerProps = MuiDividerProps;
